/**
 * GridRenderer — Dot grid overlay
 * Per PLAN.md render/GridRenderer.js and PRD §4.2
 */

import { GRID_SIZE, GRID_DOT_RADIUS } from '../utils/constants.js';

export class GridRenderer {
    /**
     * Render dot grid on canvas
     * @param {CanvasRenderingContext2D} ctx 
     * @param {import('../core/Viewport.js').Viewport} viewport 
     * @param {boolean} isDark - Dark theme flag
     */
    render(ctx, viewport, isDark = false) {
        const { width, height } = viewport;

        // Grid color from design tokens
        const dotColor = isDark ? '#2A2A2A' : '#E5E5E5';

        // Calculate visible grid range in world coordinates
        const topLeft = viewport.screenToWorld(0, 0);
        const bottomRight = viewport.screenToWorld(width, height);

        // Snap to grid lines
        const startX = Math.floor(topLeft.x / GRID_SIZE) * GRID_SIZE;
        const startY = Math.floor(topLeft.y / GRID_SIZE) * GRID_SIZE;
        const endX = Math.ceil(bottomRight.x / GRID_SIZE) * GRID_SIZE;
        const endY = Math.ceil(bottomRight.y / GRID_SIZE) * GRID_SIZE;

        // Adaptive grid density based on zoom
        let step = GRID_SIZE;
        if (viewport.zoom < 0.5) {
            step = GRID_SIZE * 4;
        } else if (viewport.zoom < 0.75) {
            step = GRID_SIZE * 2;
        }

        // Dot size scales with zoom, but has minimum
        const dotRadius = Math.max(GRID_DOT_RADIUS, GRID_DOT_RADIUS * viewport.zoom * 0.5);

        ctx.fillStyle = dotColor;
        ctx.beginPath();

        for (let x = startX; x <= endX; x += step) {
            for (let y = startY; y <= endY; y += step) {
                const screen = viewport.worldToScreen(x, y);
                ctx.moveTo(screen.x + dotRadius, screen.y);
                ctx.arc(screen.x, screen.y, dotRadius, 0, Math.PI * 2);
            }
        }

        ctx.fill();
    }
}
